import React, {useEffect, useState} from 'react';
import {Modal} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {
    getDevice,
    getDeviceEdit,
    getDeviceModalStatus,
    getDeviceTypes,
    installationSelect
} from "../../redux-store/selectors";
import {createDevice, fetchDeviceTypes, hideModal, updateDevice} from "../../redux-store/devices";
import {useForm} from "react-hook-form";
import {Select} from "antd";
import {letterSpace} from "../../constants/FunctionJS";
import ErrorIcon from "../../images/errorIcon.png";
import {REQUIRED_FIELD} from "../../constants/Messages";

const {Option} = Select

const DeviceModal = ({locationId, deviceId}) => {
    const dispatch = useDispatch();
    const {
        register,
        handleSubmit,
        formState: {errors},
        setValue,
    } = useForm();

    const installation = useSelector(installationSelect);

    const modalVisibility = useSelector(getDeviceModalStatus);
    const editing = useSelector(getDeviceEdit);
    const device = useSelector(getDevice);

    const deviceTypes = useSelector(getDeviceTypes);

    const [selectedValue, setSelectedValue] = useState(null);
    const [selectData, setSelectData] = useState([]);
    const [dataTypesMap, setDataTypesMap] = useState([]);

    const onModalClose = () => {
        dispatch(hideModal());
    }
    useEffect(() => {
        if (!modalVisibility)
            return;
        dispatch(fetchDeviceTypes());
    }, [modalVisibility]);

    useEffect(() => {
        const mappedSelectData = deviceTypes.map((item, counter) => {
            if (device === null && counter === 0)
                setSelectedValue({label: item.className, value: item.className});
            else if (device !== null && device.className === item.className)
                setSelectedValue({label: item.className, value: item.className});
            return (<Option value={item.className}>{item.className}</Option>)
        });
        setSelectData(mappedSelectData);
    }, [deviceTypes, device]);


    useEffect(() => {
        if (selectedValue === null) return;
        const concreteDevice = deviceTypes.find(item => item.className === selectedValue.value);
        if (concreteDevice === undefined) return <></>
        const {initiationParameters} = concreteDevice;
        const pomData = [];
        if (device === null)
            for (const [key, value] of Object.entries(initiationParameters)) {
                setValue(`${key}`, value);
                pomData.push({
                    name: key,
                    type: typeof value
                });
            }
        else {
            for (const [key, value] of Object.entries(device)) {
                setValue(`${key}`, value);
                pomData.push({
                    name: key,
                    type: typeof value
                });
            }
        }
        setDataTypesMap(pomData);

    }, [selectedValue]);

    const onsubmit = data => {
        const concreteDevice = deviceTypes.find(item => item.className === selectedValue.value);
        if (concreteDevice === undefined) return;
        const {initiationParameters} = concreteDevice;
        for (const [key, value] of Object.entries(data)) {
            if (!(key in initiationParameters))
                delete data[key];
        }

        for (const [key, value] of Object.entries(data)) {
            const dtype = dataTypesMap.find(item => item.name === key);
            if (dtype !== undefined && dtype.type === "number") {
                data[key] = parseInt(value);
            }
        }
        const dataObject = {
            className: selectedValue.value,
            initiationParameters: {
                ...data
            }
        }
        if (editing)
            dispatch(updateDevice({
                installationId: installation.value,
                locationId: locationId,
                deviceId: deviceId,
                data: dataObject,
            }))
        else
            dispatch(createDevice({
                installationId: installation.value,
                locationId: locationId,
                data: dataObject,
            }));
    }

    const handleDeviceTypeSelectChange = value => {
        setSelectedValue(value);
    }

    const getDeviceParameterFields = (device) => {
        if (device === null) return <></>
        const concreteDevice = deviceTypes.find(item => item.className === device.value);
        if (concreteDevice === undefined) return <></>
        const {initiationParameters} = concreteDevice;
        const fieldList = [];
        for (const [key, value] of Object.entries(initiationParameters)) {
            const fieldType = typeof value === "string" ? "text" : "number";
            fieldList.push(<div className={"row mb-3"}>
                <div className={"col-12"}>
                    <label className="mb-2 form-label me-2 first-letter-uppercase"
                           htmlFor="name">{letterSpace(key)}</label>
                    <input className="form-control" type={fieldType} {...register(key, {
                        required: true,
                    })}/>
                    {errors[key] && <span className="loggin-error"><img src={ErrorIcon}/> {REQUIRED_FIELD}</span>}
                </div>
            </div>)
        }
        return fieldList.map(item => item)
    }

    return (
        <Modal
            show={modalVisibility}
            onHide={onModalClose}
            backdrop="static"
            keyboard={false}
            size={"lg"}
        >
            <Modal.Header closeButton className={"modal-header-component"}>
                <Modal.Title>{editing ? "Ažuriranje uređаја" : "Kreiranje uređаја"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit(onsubmit)}>
                    <div className={"container device-modal"}>
                        <div className={"row mb-3"}>
                            <div className="d-flex align-items-center installation-select">
                                <label className="device-page-label">Tip uređaja</label>
                                <div className="col-7 col-md-7 col-lg-5 col-xl-4 ant-select-installations">
                                    <Select labelInValue style={{width: "200px"}} loading={false}
                                            disabled={device !== null}
                                            onChange={handleDeviceTypeSelectChange} value={selectedValue}
                                            getPopupContainer={node => node.parentNode}>
                                        {selectData}
                                    </Select>
                                </div>
                            </div>
                        </div>
                        {getDeviceParameterFields(selectedValue)}
                        <div className={"row"}>
                            <div className={"col-12"}>
                                <div className={"modal-footer-component"}>
                                    <button className={"btn btn-modal-cancel"} onClick={onModalClose} type={"button"}>
                                        {"Otkaži"}
                                    </button>
                                    <button
                                        className={"btn btn-modal-confirm"}>{editing ? "Izmjeni" : "Kreiraj"}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default DeviceModal;